/* eslint-disable */
import { useNavigate } from "react-router-dom";
import { DatePicker } from "@mui/x-date-pickers";
import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Tooltip,
  Typography,
  Autocomplete,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import SearchIcon from "@mui/icons-material/Search";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import CompareArrowsOutlinedIcon from "@mui/icons-material/CompareArrowsOutlined";
import DocumentScannerOutlinedIcon from "@mui/icons-material/DocumentScannerOutlined";
import { useEffect, useState, useContext } from "react";
import { getCacheData } from "../../services/CacheService";
import { getTarjetasDebito } from "../../../project/services/MedioCobroService";
import { getTarjetasCredito } from "../../../project/services/MedioCobroService";
import { getObraSocialPlanes } from "../../../project/services/ObraSocialPlanService";
import Message from "../../../project/utils/Message";
import { getCobranzas, invalidateCobranza } from "../../../project/services/CobranzaService";
import { retryFacturaOdoo } from "../../../project/services/FacturaService";
import WaitingDialog from "../../utils/WaitingDialog";
import AuthContext from "../../contexts/AuthContext";

const initialSearchData = {
  codigoCobranza: "",
  fechaCreacionDesde: null,
  fechaCreacionHasta: null,
  estadoActual: "todo",
  usuario: "",
  codigoGA: "",
  nombre: "",
  apellido: "",
  tipoCobro: "",
  tarjetaDebito: "",
  numeroCuponTarjetaDebito: "",
  numeroLoteTarjetaDebito: "",
  tarjetaCredito: "",
  numeroCuponTarjetaCredito: "",
  numeroLoteTarjetaCredito: "",
  billetera: "",
  obraSocial: "",
  obraSocialPlan: "",
  numeroBeneficiario: "",
  numeroAutorizacion: "",
  descripcionDescuentoEspecial: "",
  descripcionOtraFormadeCobro: "",
  cuentaBancaria: "",
  numeroComprobante: "",
  banco: "",
  numeroCheque: "",
};

const estadoOptions = [
  {
    id: "todo",
    descripcion: "Todo",
  },
  {
    id: "activo",
    descripcion: "Activo",
  },
  {
    id: "facturado",
    descripcion: "Facturado",
  },
  {
    id: "anulado",
    descripcion: "Anulado",
  },
];

const mediosDeCobroOptions = [
  {
    id: "efectivo",
    label: "Efectivo",
  },
  {
    id: "tarjeta-debito",
    label: "Tarjeta de Débito",
  },
  {
    id: "tarjeta-credito",
    label: "Tarjeta de Crédito",
  },
  {
    id: "billetera-virtual",
    label: "Billetera Virtual",
  },
  {
    id: "obra-social",
    label: "Obra Social",
  },
  {
    id: "descuento-especial",
    label: "Descuento especial",
  },
  {
    id: "otro",
    label: "Otra forma de pago",
  },
  {
    id: "transferencia-bancaria",
    label: "Transferencia Bancaria",
  },
  {
    id: "cheque",
    label: "Cheque",
  },
];

const nameItemsText = "Cobranzas";
//
// #############################################################################
//
const CobranzaTable = () => {
  const navigate = useNavigate();
  const [searchData, setSearchData] = useState(initialSearchData);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [tarjetasDebito, setTarjetasDebito] = useState([]);
  const [tarjetasCredito, setTarjetasCredito] = useState([]);
  const [cuentasBancarias, setCuentasBancarias] = useState([]);
  const [billeteras, setBilleteras] = useState([]);
  const [obrasSociales, setObrasSociales] = useState([]);
  const [obraSocialPlanes, setObraSocialPlanes] = useState([]);
  const [cobranzas, setCobranzas] = useState([]);
  const [cobranzaSelected, setCobranzaSelected] = useState([]);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [totalRowsCount, setTotalRowsCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [openDialogConfirmaAnulacion, setOpenDialogConfirmaAnulacion] = useState(false);
  const [idCobranzaAnular, setIdCobranzaAnular] = useState("");
  const [valueACMedioDeCobro, setValueACMedioDeCobro] = useState({
    id: "",
    label: "",
  });
  const [inputValueACMedioDeCobro, setInputValueACMedioDeCobro] = useState("");
  const [usuarios, setUsuarios] = useState([])

  const { hasPermission } = useContext(AuthContext);
  const _cobranzaAnular = hasPermission("cobranza-a");
  const _cobranzaFacturar = hasPermission("cobranza-b");
  const _facturaVer = hasPermission("comprobante-venta-b");

  const tableColumns = [
    {
      field: "codigo",
      headerName: "Código",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.codigo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "fecha_creacion",
      headerName: "Fecha Creación",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.fecha_creacion;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "cliente",
      headerName: "Cliente",
      headerAlign: "center",
      align: "left",
      flex: 3,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.nombre_cliente +
          " " +
          params.row.apellido_cliente;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "importe_total_cobrado",
      headerName: "Total cobrado",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.importe_total_cobrado + params.row.importe_total_recargo;
        _val = _val ? _val.toFixed(2) : "";
        return _val;
      },
    },
    {
      field: "estado",
      headerName: "Estado",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = "ERR";
        switch (params.row.estado) {
          case "activo":
            _val = "ACTIVO";
            break;
          case "facturado":
            _val = "FACTURADO";
            break;
          case "anulado":
            _val = "ANULADO";
            break;
        }
        return _val;
      },
    },
    {
      field: "facturado",
      headerName: "Facturado?",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.emitir_factura
          ? params.row.numero_factura
            ? ""
            : "NO"
          : "";
        return _val;
      },
    },
    {
      field: "numero_factura",
      headerName: "Nro.Factura?",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.numero_factura;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "odoo_updated",
      headerName: "Odoo ?",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.odoo_updated ? "" : "NO";
        return _val;
      },
    },
    {
      field: "usuario",
      headerName: "Vendedor",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.usuario;
        _val = _val ? _val.toLowerCase() : "";
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      headerAlign: "center",
      align: "center",
      width: 150,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          {/* 
            siempre esta la accion de ver cobranza 
            accion >> ver la cobranza
            */}
          <Tooltip title="ver cobranza">
            <IconButton
              size="small"
              aria-label="update"
              onClick={() => verCobranza(params.row, "view")}
            >
              <RemoveRedEyeOutlinedIcon />
            </IconButton>
          </Tooltip>

          {/* 
            si la cobranza esta activa y
            y no se debe emitir factura para esta cobranza
            accion >> anular la cobranza
            */}
          {params.row.estado === "activo" && !params.row.emitir_factura && _cobranzaAnular && (
            <Tooltip title="anular cobranza">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() => {
                  setIdCobranzaAnular(params.row.id);
                  setOpenDialogConfirmaAnulacion(true);
                }}
              >
                <RemoveCircleOutlineIcon />
              </IconButton>
            </Tooltip>
          )}

          {/* 
            si la cobranza esta activa y
            y si se debe emitir factura para esta cobranza
            y la cobranza todavia no tiene factura en olp
            accion >> facturar la cobranaza | anular la cobranza
            */}
          {params.row.estado === "activo" &&
            params.row.emitir_factura &&
            !params.row.tiene_factura && _cobranzaFacturar && (
              <>
                <Tooltip title="facturar">
                  <IconButton
                    size="small"
                    aria-label="update"
                    onClick={() => facturarCobranza(params.row)}
                  >
                    <DescriptionOutlinedIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="anular cobranza">
                  <IconButton
                    size="small"
                    aria-label="update"
                    onClick={() => {
                      setIdCobranzaAnular(params.row.id);
                      setOpenDialogConfirmaAnulacion(true);
                    }}
                  >
                    <RemoveCircleOutlineIcon />
                  </IconButton>
                </Tooltip>
              </>
            )}

          {/* 
            si la cobranza esta activa y
            y si se debe emitir factura para esta cobranza
            y la cobranza ya tiene factura en olp
            y la factura se encuentra ok en odoo
            accion >> ver la factura | anular la cobranza
            */}
          {params.row.estado === "activo" &&
            params.row.emitir_factura &&
            params.row.tiene_factura &&
            params.row.odoo_updated && (
              <Tooltip title="ver factura">
                <IconButton
                  size="small"
                  aria-label="update"
                  onClick={() => verFactura(params.row)}
                >
                  <DocumentScannerOutlinedIcon />
                </IconButton>
              </Tooltip>
            )}

          {/* 
            si la cobranza esta activa y
            y si se debe emitir factura para esta cobranza
            y la cobranza ya tiene factura
            y la factura no se encuentra ok en odoo
            accion >> ver la factura | reintentar la factura en odoo
            */}
          {params.row.estado === "activo" &&
            params.row.emitir_factura &&
            params.row.tiene_factura &&
            !params.row.odoo_updated && _facturaVer && (
              <>
                <Tooltip title="ver factura">
                  <IconButton
                    size="small"
                    aria-label="update"
                    onClick={() => verFactura(params.row)}
                  >
                    <DocumentScannerOutlinedIcon />
                  </IconButton>
                </Tooltip>

                <Tooltip title="reintentar factura en odoo">
                  <IconButton
                    size="small"
                    aria-label="update"
                    onClick={() => reintentarFacturaEnOdoo(params.row)}
                    color="error"
                  >
                    <CompareArrowsOutlinedIcon />
                  </IconButton>
                </Tooltip>
              </>
            )}
        </>
      ),
    },
  ];

  const handlePaginationModelChange = (newModel) => {
    setCurrentPage(newModel.page);
    setRowsPerPage(newModel.pageSize);
  };

  const tableOptions = {
    paginationMode: "server",
    rowCount: totalRowsCount,
    paginationModel: {
      page: currentPage,
      pageSize: rowsPerPage,
    },
    onPaginationModelChange: handlePaginationModelChange,
    pageSizeOptions: [10, 20, 30],
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
      MuiTablePagination: {
        labelRowsPerPage: "Filas:",
        labelDisplayedRows: ({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`,
      },
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    loadTarjetasDebito();
    loadTarjetasCredito();
    loadCuentasBancarias();
    loadBilleteras();
    loadObrasSociales();
    loadObraSocialPlanes();
    loadUsuarios();
  }, []);
  //
  // ################################################################################
  //
  useEffect(() => {
    load();
  }, [currentPage, rowsPerPage]);
  //
  // ################################################################################
  //
  const loadTarjetasDebito = async () => {
    const response = await getTarjetasDebito();
    if (response.ok) {
      let _tarjetasDebito = [];
      let _tarjeta = {};
      let _descripcion = "";

      response.data.data.forEach((item) => {
        _descripcion =
          item.marca_tarjeta.toUpperCase() +
          " - " +
          item.banco_entidad.toUpperCase() +
          (item.porcentaje_descuento > 0
            ? " - " + item.porcentaje_descuento + " % descuento"
            : "");

        _tarjeta = {
          idTarjeta: item.id_tarjeta,
          idTarjetaBanco: item.id_tarjeta_banco,
          idTarjetaBancoAcuerdo: item.id_tarjeta_banco_acuerdo,
          id: item.id_tarjeta_banco_acuerdo,
          porcentajeDescuento: item.porcentaje_descuento,
          tarjeta: _descripcion,
          label: _descripcion,
        };
        _tarjetasDebito.push(_tarjeta);
      });
      setTarjetasDebito(_tarjetasDebito);
    } else {
      setTarjetasDebito([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadTarjetasCredito = async () => {
    const response = await getTarjetasCredito();
    if (response.ok) {
      let _tarjetasCredito = [];
      let _tarjeta = {};
      let _descripcion = "";

      response.data.data.forEach((item) => {
        _descripcion =
          item.marca_tarjeta.toUpperCase() +
          " - " +
          item.banco_entidad.toUpperCase() +
          " - " +
          item.cantidad_cuotas +
          (item.cantidad_cuotas === 1 ? " cuota" : " cuotas") +
          (item.porcentaje_descuento > 0
            ? " - " + item.porcentaje_descuento + " % descuento"
            : "") +
          (item.porcentaje_interes > 0 ? " - " + item.porcentaje_interes + " % interés" : "");
        _tarjeta = {
          idTarjeta: item.id_tarjeta,
          idTarjetaBanco: item.id_tarjeta_banco,
          idTarjetaBancoAcuerdo: item.id_tarjeta_banco_acuerdo,
          id: item.id_tarjeta_banco_acuerdo,
          porcentajeDescuento: item.porcentaje_descuento,
          porcentajeInteres: item.porcentaje_interes,
          cantidadCuotas: item.cantidad_cuotas,
          tarjeta: _descripcion,
          label: _descripcion,
        };
        _tarjetasCredito.push(_tarjeta);
      });
      setTarjetasCredito(_tarjetasCredito);
    } else {
      setTarjetasCredito([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadCuentasBancarias = async () => {
    const response = await getCacheData("cuenta_bancaria");
    if (response.ok) {

      let _cuentasBancarias = [];
      let _cuentaBancaria = {};
      let _descripcion = "";

      response.data.data.forEach((item) => {
        _descripcion = item.banco.toUpperCase() + " - CBU: " + item.numero_cbu.toUpperCase();
        _cuentaBancaria = {
          id: item.id,
          idCuentaBancaria: item.id,
          bancoCuentaBancaria: _descripcion,
          label: _descripcion,
        };
        _cuentasBancarias.push(_cuentaBancaria);
      });
      setCuentasBancarias(_cuentasBancarias);
    } else {
      setCuentasBancarias([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadBilleteras = async () => {
    const response = await getCacheData('billetera');
    if (response.ok) {
      setBilleteras(response.data.data);
    } else {
      setBilleteras([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadObrasSociales = async () => {
    const response = await getCacheData('obra_social');
    if (response.ok) {
      setObrasSociales(response.data.data);
    } else {
      setObrasSociales([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadObraSocialPlanes = async () => {
    const response = await getObraSocialPlanes();
    if (response.ok) {
      setObraSocialPlanes(response.data.data);
    } else {
      setObraSocialPlanes([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadUsuarios = async () => {
    const response = await getCacheData('usuario');
    if (response.ok) {
      setUsuarios(response.data.data);
    } else {
      setUsuarios([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  }
  //
  // ################################################################################
  //
  const verCobranza = (parRow, parAction) => {
    let _url = `/cobranza/${parRow.id}/${parAction}`;
    window.open(_url, "_blank");
  };
  //
  // ################################################################################
  //
  const facturarCobranza = (parRow) => {
    let _url = `/factura/${parRow.id}`;
    window.open(_url, "_blank");
  };
  //
  // ################################################################################
  //
  const verFactura = (parRow) => {
    let _url = `/factura-ver/${parRow.id_comprobante_venta}`;
    window.open(_url, "_blank");
  };
  //
  // ################################################################################
  //
  const reintentarFacturaEnOdoo = (parRow) => {

    const reintentar = async () => {
      setIsDoingSomething(true);
      const response = await retryFacturaOdoo(parRow.id_comprobante_venta);
      setIsDoingSomething(false);

      if (response.ok) {
        setCobranzaSelected([]);
        setTotalRowsCount(response.data.count);
        setCobranzas(response.data.data);
      } else {
        setMessage({
          messageText: response.messageText,
          severity: response.messageSeverity,
        });
        setShowMessage(true);
      }
    };

    reintentar();
    load();
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setSearchData({
      ...searchData,
      [e.target.name]: e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeFechaCreacionDesde = (fecha) => {
    setSearchData({
      ...searchData,
      fechaCreacionDesde: fecha,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeFechaCreacionHasta = (fecha) => {
    setSearchData({
      ...searchData,
      fechaCreacionHasta: fecha,
    });
  };
  //
  // ################################################################################
  //
  const handleLimpiar = () => {
    setSearchData(initialSearchData);
    setValueACMedioDeCobro({ id: "", label: "" });
    setInputValueACMedioDeCobro("");
    setTotalRowsCount(0);
    setCobranzas([]);
    setCobranzaSelected([]);
    setCurrentPage(0);
  };
  //
  // ################################################################################
  //
  const handleBuscar = () => {
    load();
  };
  //
  // ################################################################################
  //
  const load = async () => {
    let _params = {
      codigoCobranza: searchData.codigoCobranza,
      fechaCreacionDesde: searchData.fechaCreacionDesde,
      fechaCreacionHasta: searchData.fechaCreacionHasta,
      estadoActual: searchData.estadoActual,
      usuario: searchData.usuario,
      codigoGA: searchData.codigoGA,
      nombre: searchData.nombre,
      apellido: searchData.apellido,
      tipoCobro: searchData.tipoCobro,
      tarjetaDebito: searchData.tarjetaDebito,
      numeroCuponTarjetaDebito: searchData.numeroCuponTarjetaDebito,
      numeroLoteTarjetaDebito: searchData.numeroLoteTarjetaDebito,
      tarjetaCredito: searchData.tarjetaCredito,
      numeroCuponTarjetaCredito: searchData.numeroCuponTarjetaCredito,
      numeroLoteTarjetaCredito: searchData.numeroLoteTarjetaCredito,
      billetera: searchData.billetera,
      obraSocial: searchData.obraSocial,
      obraSocialPlan: searchData.obraSocialPlan,
      numeroBeneficiario: searchData.numeroBeneficiario,
      numeroAutorizacion: searchData.numeroAutorizacion,
      descripcionDescuentoEspecial: searchData.descripcionDescuentoEspecial,
      descripcionOtraFormadeCobro: searchData.descripcionOtraFormadeCobro,
      cuentaBancaria: searchData.cuentaBancaria,
      numeroComprobante: searchData.numeroComprobante,
      banco: searchData.banco,
      numeroCheque: searchData.numeroCheque,
      rows: rowsPerPage,
      first: currentPage * rowsPerPage,
    };

    setIsDoingSomething(true);
    const response = await getCobranzas(_params);
    setIsDoingSomething(false);

    if (response.ok) {
      setCobranzaSelected([]);
      setTotalRowsCount(response.data.count);
      setCobranzas(response.data.data);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const handleCloseDialogConfirmaAnulacion = (parConfirmaAnulacion) => {
    parConfirmaAnulacion = typeof parConfirmaAnulacion == "boolean" ? parConfirmaAnulacion : false;

    if (parConfirmaAnulacion) {
      anulaCobranza(idCobranzaAnular);
    }
    setOpenDialogConfirmaAnulacion(false);
  };
  //
  // ################################################################################
  //
  const anulaCobranza = async (parIdCobranza) => {

    setIsDoingSomething(true);
    const response = await invalidateCobranza(parIdCobranza);
    setIsDoingSomething(false);

    if (response.ok) {
      load();
    }

    setMessage({
      severity: response.messageSeverity,
      messageText: response.messageText,
    });
    setShowMessage(true);
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={0} sx={{ mx: 0.5, maxWidth: "100%" }}>
        <Paper elevation={1} >
          <Box sx={{ mx: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Box sx={{ mt: 1 }} display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="h5" display="cristal" gutterBottom >
                    {nameItemsText}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="codigoCobranza"
                  label="Código de Cobranza"
                  variant="outlined"
                  size="small"
                  name="codigoCobranza"
                  value={searchData.codigoCobranza}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <DatePicker
                  sx={{
                    width: "100%",
                    '& .MuiInputLabel-root': {
                      transform: 'translate(14px, 9px) scale(1)',
                    },
                    '& .MuiInputBase-root': {
                      paddingRight: '10px',
                    },
                    '& .MuiInputLabel-shrink': {
                      transform: 'translate(14px, -8px) scale(0.75)',
                    },
                  }}
                  id="fechaCreacionDesde"
                  label="Desde fecha"
                  variant="outlined"
                  name="fechaCreacionDesde"
                  value={searchData.fechaCreacionDesde}
                  format="dd/MM/yyyy"
                  maxDate={new Date()}
                  onChange={(newValue) =>
                    handleChangeFechaCreacionDesde(newValue)
                  }
                  slots={{ textField: TextField }}
                  slotProps={{
                    textField: {
                      size: "small",
                      sx: { width: "100%" },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <DatePicker
                  sx={{
                    width: "100%",
                    '& .MuiInputLabel-root': {
                      transform: 'translate(14px, 9px) scale(1)',
                    },
                    '& .MuiInputBase-root': {
                      paddingRight: '10px',
                    },
                    '& .MuiInputLabel-shrink': {
                      transform: 'translate(14px, -8px) scale(0.75)',
                    },
                  }}
                  id="fechaCreacionHasta"
                  label="Hasta fecha"
                  variant="outlined"
                  name="fechaCreacionHasta"
                  value={searchData.fechaCreacionHasta}
                  format="dd/MM/yyyy"
                  maxDate={new Date()}
                  onChange={(newValue) =>
                    handleChangeFechaCreacionHasta(newValue)
                  }
                  slots={{ textField: TextField }}
                  slotProps={{
                    textField: {
                      size: "small",
                      sx: { width: "100%" },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <FormControl sx={{ width: "100%" }}>
                  <InputLabel id="estado-actual-select-label">Estado actual</InputLabel>
                  <Select
                    labelId="estado-actual-select-label"
                    id="estado-actual-select"
                    name="estadoActual"
                    value={searchData.estadoActual}
                    label="Estado actual"
                    size="small"
                    onChange={handleChange}
                    MenuProps={{ style: { maxHeight: "300px" } }}
                  >
                    {estadoOptions.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.descripcion}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <FormControl sx={{ width: "100%" }}>
                  <InputLabel
                    id="usuario-select-label"
                    sx={{
                      transform: "translate(15px, 10px) scale(1)",
                      "&.MuiInputLabel-shrink": {
                        transform: "translate(14px, -8px) scale(0.75)", // Ajuste para cuando el label se reduce
                      },
                    }}
                  >
                    Usuario
                  </InputLabel>
                  <Select
                    labelId="usuario-select-label"
                    id="usuario-select"
                    name="usuario"
                    value={searchData.usuario}
                    label="Vendedor"
                    size="small"
                    onChange={handleChange}
                    MenuProps={{ style: { maxHeight: "300px" } }}
                  >
                    {usuarios.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.nombre}, {item.apellido}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="codigoGA"
                  label="Código de Gestión de Atención"
                  variant="outlined"
                  size="small"
                  name="codigoGA"
                  value={searchData.codigoGA}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="nombre"
                  label="Nombre de Cliente"
                  variant="outlined"
                  size="small"
                  name="nombre"
                  value={searchData.nombre}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="apellido"
                  label="Apellido de Cliente"
                  variant="outlined"
                  size="small"
                  name="apellido"
                  value={searchData.apellido}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="mediosDeCobro"
                  size="small"
                  width="50%"
                  value={valueACMedioDeCobro}
                  onChange={(event, newValue) => {
                    setValueACMedioDeCobro(newValue);
                    setSearchData((prevData) => ({
                      ...prevData,
                      tipoCobro: newValue || newValue.id ? newValue.id : "",
                    }));
                  }}
                  inputValue={inputValueACMedioDeCobro}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACMedioDeCobro(newInputValue);
                  }}
                  options={mediosDeCobroOptions}
                  renderInput={(params) => (
                    <TextField {...params} label="Medio de Cobro" />
                  )}
                  isOptionEqualToValue={(option, value) =>
                    value === null || option.value === value.value
                  }
                  disableClearable={true}
                />
              </Grid>

              {valueACMedioDeCobro.id === "tarjeta-debito" && (
                <>
                  <Grid item xs={12} md={12} lg={2}>
                    <FormControl sx={{ width: "100%" }}>
                      <InputLabel id="tarjeta-debito-select-label">Tarjeta de Débito</InputLabel>
                      <Select
                        labelId="tarjeta-debito-select-label"
                        id="tarjeta-debito-select"
                        name="tarjetaDebito"
                        value={searchData.tarjetaDebito}
                        label="Tarjeta de Débito"
                        size="small"
                        onChange={handleChange}
                        MenuProps={{ style: { maxHeight: "300px" } }}
                      >
                        {tarjetasDebito.map((item) => (
                          <MenuItem
                            key={item.idTarjetaBancoAcuerdo}
                            value={item.idTarjetaBancoAcuerdo}
                          >
                            {item.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <TextField
                      sx={{ width: "100%" }}
                      inputProps={{
                        autoComplete: "off",
                      }}
                      id="numeroCuponTarjetaDebito"
                      label="Número de Cupón"
                      variant="outlined"
                      size="small"
                      name="numeroCuponTarjetaDebito"
                      value={searchData.numeroCuponTarjetaDebito}
                      onChange={handleChange}
                    />
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <TextField
                      sx={{ width: "100%" }}
                      inputProps={{
                        autoComplete: "off",
                      }}
                      id="numeroLoteTarjetaDebito"
                      label="Número de Lote"
                      variant="outlined"
                      size="small"
                      name="numeroLoteTarjetaDebito"
                      value={searchData.numeroLoteTarjetaDebito}
                      onChange={handleChange}
                    />
                  </Grid>
                </>
              )}

              {valueACMedioDeCobro.id === "tarjeta-credito" && (
                <>
                  <Grid item xs={12} md={12} lg={2}>
                    <FormControl sx={{ width: "100%" }}>
                      <InputLabel id="tarjeta-credito-select-label">Tarjeta de Crédito</InputLabel>
                      <Select
                        labelId="tarjeta-credito-select-label"
                        id="tarjeta-credito-select"
                        name="tarjetaCredito"
                        value={searchData.tarjetaCredito}
                        label="Tarjeta de Crédito"
                        size="small"
                        onChange={handleChange}
                        MenuProps={{ style: { maxHeight: "300px" } }}
                      >
                        {tarjetasCredito.map((item) => (
                          <MenuItem
                            key={item.idTarjetaBancoAcuerdo}
                            value={item.idTarjetaBancoAcuerdo}
                          >
                            {item.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <TextField
                      sx={{ width: "100%" }}
                      inputProps={{
                        autoComplete: "off",
                      }}
                      id="numeroCuponTarjetaCredito"
                      label="Número de Cupón"
                      variant="outlined"
                      size="small"
                      name="numeroCuponTarjetaCredito"
                      value={searchData.numeroCuponTarjetaCredito}
                      onChange={handleChange}
                    />
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <TextField
                      sx={{ width: "100%" }}
                      inputProps={{
                        autoComplete: "off",
                      }}
                      id="numeroLoteTarjetaCredito"
                      label="Número de Lote"
                      variant="outlined"
                      size="small"
                      name="numeroLoteTarjetaCredito"
                      value={searchData.numeroLoteTarjetaCredito}
                      onChange={handleChange}
                    />
                  </Grid>
                </>
              )}

              {valueACMedioDeCobro.id === "billetera-virtual" && (
                <>
                  <Grid item xs={12} md={12} lg={2}>
                    <FormControl sx={{ width: "100%" }}>
                      <InputLabel id="billetera-select-label">Billetera Virtual</InputLabel>
                      <Select
                        labelId="billetera-select-label"
                        id="billetera-select"
                        name="billetera"
                        value={searchData.billetera}
                        label="Billetera"
                        size="small"
                        onChange={handleChange}
                        MenuProps={{ style: { maxHeight: "300px" } }}
                      >
                        {billeteras.map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.descripcion}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </>
              )}

              {valueACMedioDeCobro.id === "obra-social" && (
                <>
                  <Grid item xs={12} md={12} lg={2}>
                    <FormControl sx={{ width: "100%" }}>
                      <InputLabel id="obra-social-select-label">Obra Social</InputLabel>
                      <Select
                        labelId="obra-social-select-label"
                        id="obra-social-select"
                        name="obraSocial"
                        value={searchData.obraSocial}
                        label="Obra Social"
                        size="small"
                        onChange={handleChange}
                        MenuProps={{ style: { maxHeight: "300px" } }}
                      >
                        {obrasSociales.map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.descripcion}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <FormControl sx={{ width: "100%" }}>
                      <InputLabel id="obra-social-plan-select-label">
                        Plan de Obra Social
                      </InputLabel>
                      <Select
                        labelId="obra-social-plan-select-label"
                        id="obra-social-plan-select"
                        name="obraSocialPlan"
                        value={searchData.obraSocialPlan}
                        label="Plan de Obra Social"
                        size="small"
                        onChange={handleChange}
                        MenuProps={{ style: { maxHeight: "300px" } }}
                      >
                        {obraSocialPlanes.map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.descripcion_obra_social} - {item.descripcion_obra_social_plan}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <TextField
                      sx={{ width: "100%" }}
                      inputProps={{
                        autoComplete: "off",
                      }}
                      id="numeroBeneficiario"
                      label="Número de Beneficiario"
                      variant="outlined"
                      size="small"
                      name="numeroBeneficiario"
                      value={searchData.numeroBeneficiario}
                      onChange={handleChange}
                    />
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <TextField
                      sx={{ width: "100%" }}
                      inputProps={{
                        autoComplete: "off",
                      }}
                      id="numeroAutorizacion"
                      label="Número de Autorización"
                      variant="outlined"
                      size="small"
                      name="numeroAutorizacion"
                      value={searchData.numeroAutorizacion}
                      onChange={handleChange}
                    />
                  </Grid>
                </>
              )}

              {valueACMedioDeCobro.id === "descuento-especial" && (
                <>
                  <Grid item xs={12} md={12} lg={2}>
                    <TextField
                      sx={{ width: "100%" }}
                      inputProps={{
                        autoComplete: "off",
                      }}
                      id="descripcionDescuentoEspecial"
                      label="Descripción"
                      variant="outlined"
                      size="small"
                      name="descripcionDescuentoEspecial"
                      value={searchData.descripcionDescuentoEspecial}
                      onChange={handleChange}
                    />
                  </Grid>
                </>
              )}

              {valueACMedioDeCobro.id === "otro" && (
                <>
                  <Grid item xs={12} md={12} lg={2}>
                    <TextField
                      sx={{ width: "100%" }}
                      inputProps={{
                        autoComplete: "off",
                      }}
                      id="descripcionOtraFormadeCobro"
                      label="Descripción"
                      variant="outlined"
                      size="small"
                      name="descripcionOtraFormadeCobro"
                      value={searchData.descripcionOtraFormadeCobro}
                      onChange={handleChange}
                    />
                  </Grid>
                </>
              )}

              {valueACMedioDeCobro.id === "transferencia-bancaria" && (
                <>
                  <Grid item xs={12} md={12} lg={2}>
                    <FormControl sx={{ width: "100%" }}>
                      <InputLabel id="cuenta-bancaria-select-label">Cuenta Bancaria</InputLabel>
                      <Select
                        labelId="cuenta-bancaria-select-label"
                        id="cuenta-bancaria-select"
                        name="cuentaBancaria"
                        value={searchData.cuentaBancaria}
                        label="Cuenta Bancaria"
                        size="small"
                        onChange={handleChange}
                        MenuProps={{ style: { maxHeight: "300px" } }}
                      >
                        {cuentasBancarias.map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <TextField
                      sx={{ width: "100%" }}
                      inputProps={{
                        autoComplete: "off",
                      }}
                      id="numeroComprobante"
                      label="Número de Comprobante"
                      variant="outlined"
                      size="small"
                      name="numeroComprobante"
                      value={searchData.numeroComprobante}
                      onChange={handleChange}
                    />
                  </Grid>
                </>
              )}

              {valueACMedioDeCobro.id === "cheque" && (
                <>
                  <Grid item xs={12} md={12} lg={2}>
                    <TextField
                      sx={{ width: "100%" }}
                      inputProps={{
                        autoComplete: "off",
                      }}
                      id="banco"
                      label="Banco"
                      variant="outlined"
                      size="small"
                      name="banco"
                      value={searchData.banco}
                      onChange={handleChange}
                    />
                  </Grid>

                  <Grid item xs={12} md={12} lg={2}>
                    <TextField
                      sx={{ width: "100%" }}
                      inputProps={{
                        autoComplete: "off",
                      }}
                      id="numeroCheque"
                      label="Número de Cheque"
                      variant="outlined"
                      size="small"
                      name="numeroCheque"
                      value={searchData.numeroCheque}
                      onChange={handleChange}
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </Box>

          <Box sx={{ mx: 1, mb: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="buscar">
                    <Button
                      fullWidth
                      variant="contained"
                      size="small"
                      onClick={handleBuscar}
                      startIcon={<SearchIcon />}
                    >
                      Buscar
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>

              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="limpiar filtros de búsqueda">
                    <Button
                      fullWidth
                      variant="outlined"
                      size="small"
                      onClick={handleLimpiar}
                      startIcon={<CleaningServicesIcon />}
                    >
                      Limpiar
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Paper>

        <DataGrid
          rows={cobranzas}
          columns={tableColumns}
          {...tableOptions}
        />
      </Paper>

      <Dialog
        open={openDialogConfirmaAnulacion}
        onClose={handleCloseDialogConfirmaAnulacion}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Anulación de Cobranza"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Estás seguro que querés anular esta Cobranza?
            Esta acción es irreversible.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleCloseDialogConfirmaAnulacion(true)}>
            Anular la Cobranza
          </Button>
          <Button onClick={() => handleCloseDialogConfirmaAnulacion(false)} autoFocus>
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default CobranzaTable;